// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1mrMq","primary":"Button_primary__2nxhy","main":"Button_main__ENYwr","small":"Button_small__lRKN_"};